var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVuesaxOutlineShoppingBag(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor",
    "data-name": "vuesax/outline/shopping-bag"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.49 22.75H7.5a4.853 4.853 0 01-3.81-1.37 4.855 4.855 0 01-.9-3.94l.9-7.5c.26-2.21.82-4.19 4.72-4.19h7.2c3.89 0 4.45 1.98 4.72 4.19l.9 7.5a4.882 4.882 0 01-.9 3.94 4.953 4.953 0 01-3.84 1.37zM8.4 7.25c-2.88 0-3.02 1.14-3.23 2.86l-.9 7.5a3.474 3.474 0 00.54 2.77 3.5 3.5 0 002.69.86h8.99a3.5 3.5 0 002.69-.86 3.474 3.474 0 00.54-2.77l-.9-7.5c-.21-1.73-.34-2.86-3.23-2.86z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Vector",
    d: "M16 8.75a.755.755 0 01-.75-.75V4.5a1.623 1.623 0 00-1.75-1.75h-3A1.623 1.623 0 008.75 4.5V8a.755.755 0 01-.75.75.755.755 0 01-.75-.75V4.5a3.113 3.113 0 013.25-3.25h3a3.113 3.113 0 013.25 3.25V8a.755.755 0 01-.75.75zM20.41 17.78H8a.755.755 0 01-.75-.75.755.755 0 01.75-.75h12.41a.755.755 0 01.75.75.755.755 0 01-.75.75z"
  }))));
}
export default SvgVuesaxOutlineShoppingBag;